export enum LearningResourceType {
  AdditionalResource = 'additional_resource',
  Learning = 'learning',
  Practice = 'practice',
}

export enum RecommendationIntent {
  Learn = 'Learn',
  Test = 'Test',
}

export enum RecommendationResourceType {
  Resource = 'Resource',
  Test = 'Test',
}

export enum StandardResourceMappingType {
  Supporting = 'supporting',
  Essential = 'essential',
  NotEssential = 'not_essential',
  BestLearning = 'best_learning',
  BestPractice = 'best_practice',
  External = 'external',
}
